/**
 * Trigger a browser download for an in-memory Blob.
 *
 * Canonical home for the object-URL + anchor-click + revoke dance so call
 * sites don't re-implement it (and so a fix — Safari revoke timing, etc. —
 * lives in one place).
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
